module.exports = __webpack_public_path__ + "img/1.342a470b.png";